import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/painelOperador.css';
import '../styles/gestaoBpoRh.css';

// BPO RH → Operadoras: cadastro de quem atende os clientes e envia os e-mails.
// A senha de app do Gmail só é gravada (nunca volta do servidor); a tela mostra
// apenas se existe. Inativar não apaga: envios antigos continuam apontando
// para a pessoa.

const API = process.env.REACT_APP_API_BASE;
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });
const VAZIO = { nome: '', email: '', whatsapp: '', apelidos: '', senha_app: '' };

export default function BpoRhOperadores() {
  const [ops, setOps] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [msg, setMsg] = useState('');
  const [form, setForm] = useState(null);       // { id?, ...campos } — modal de novo/edição
  const [salvando, setSalvando] = useState(false);
  const [verInativas, setVerInativas] = useState(false);

  const carregar = useCallback(() => {
    setCarregando(true);
    axios.get(`${API}/api/bporh/operadores/`, { params: { _: Date.now() }, headers: headers() })
      .then((r) => { setOps(r.data.operadores || []); setErro(''); })
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível carregar'))
      .finally(() => setCarregando(false));
  }, []);
  useEffect(() => { carregar(); }, [carregar]);

  const salvar = () => {
    if (!form) return;
    setSalvando(true);
    const corpo = { nome: form.nome, email: form.email, whatsapp: form.whatsapp, apelidos: form.apelidos };
    if (form.senha_app) corpo.senha_app = form.senha_app;         // vazio = mantém a que existe
    const req = form.id
      ? axios.patch(`${API}/api/bporh/operadores/${form.id}/`, corpo, { headers: headers() })
      : axios.post(`${API}/api/bporh/operadores/`, corpo, { headers: headers() });
    req.then((r) => { setMsg(r.data.mensagem); setOps(r.data.operadores || []); setForm(null); })
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível salvar'))
      .finally(() => setSalvando(false));
  };
  const alternarAtivo = (o) => {
    axios.patch(`${API}/api/bporh/operadores/${o.id}/`, { ativo: !o.ativo }, { headers: headers() })
      .then((r) => { setMsg(r.data.mensagem); setOps(r.data.operadores || []); })
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível alterar'));
  };
  const limparSenha = (o) => {
    if (!window.confirm(`Apagar a senha de app de ${o.nome}? Ela deixa de conseguir enviar e-mails até cadastrar outra.`)) return;
    axios.patch(`${API}/api/bporh/operadores/${o.id}/`, { senha_app: '' }, { headers: headers() })
      .then((r) => { setMsg('Senha de app apagada'); setOps(r.data.operadores || []); })
      .catch((e) => setErro(e.response?.data?.mensagem || 'Não foi possível alterar'));
  };

  const lista = (ops || []).filter((o) => verInativas || o.ativo);

  return (
    <div className="painel-op">
      <div className="container-fluid mt-4 shadow p-4 rounded bg-white">
        <div className="header-wrapper d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
          <div className="d-flex align-items-center">
            <i className="fas fa-id-badge header-icon me-2" aria-hidden="true"></i>
            <h2 className="titulo-pagina m-0">BPO RH — Operadoras</h2>
          </div>
          <div className="gr-toolbar">
            <label className="gr-campo" title="Mostrar também as inativas">
              <input type="checkbox" checked={verInativas} onChange={(e) => setVerInativas(e.target.checked)} style={{ marginRight: 6 }} />ver inativas
            </label>
            <button type="button" className="gr-btn" onClick={carregar} disabled={carregando}>
              <i className={`fas ${carregando ? 'fa-spinner fa-spin' : 'fa-rotate'}`} aria-hidden="true"></i>Atualizar
            </button>
            <button type="button" className="gr-btn primaria" onClick={() => setForm({ ...VAZIO })}>
              <i className="fas fa-user-plus" aria-hidden="true"></i>Nova operadora
            </button>
          </div>
        </div>

        <div className="alert alert-light border small py-2">
          <i className="fas fa-circle-info me-2 text-primary"></i>
          Quem está aqui aparece no Painel do Operador, no boletim diário e como remetente dos e-mails (ponto, contratos, boleto,
          fechamento, financeiro). <b>Apelidos</b> são os nomes usados no campo "operador" da empresa ("Fran", "Vitoria") — é por eles que a
          carteira é montada. A <b>senha de app</b> do Gmail é gravada e nunca mostrada; sem ela a pessoa não envia e-mail.
        </div>
        {erro && <div className="alert alert-danger py-2" role="button" onClick={() => setErro('')}><i className="fas fa-circle-exclamation me-2"></i>{erro}</div>}
        {msg && <div className="alert alert-success py-2" role="button" onClick={() => setMsg('')}><i className="fas fa-circle-check me-2"></i>{msg}</div>}

        {carregando && !ops ? (
          <div className="text-center py-5 text-muted"><i className="fas fa-spinner fa-spin fa-3x mb-3" style={{ color: '#00b5cc' }}></i><div className="fs-5">Carregando operadoras...</div></div>
        ) : (
          <section className="po-card po-enter">
            <header className="po-card-head">
              <h3><i className="fas fa-users" aria-hidden="true"></i>Operadoras</h3>
              <span className="badge bg-light text-dark">{lista.length}</span>
            </header>
            <div className="po-card-body">
              <div className="po-scroll">
                <table className="table table-hover po-table align-middle mb-0">
                  <thead><tr><th>Nome</th><th>E-mail (remetente)</th><th>WhatsApp</th><th>Apelidos</th><th>Login no Saber</th><th>Carteira</th><th>Senha de app</th><th>Situação</th><th></th></tr></thead>
                  <tbody>
                    {lista.map((o) => (
                      <tr key={o.id} style={o.ativo ? undefined : { opacity: .55 }}>
                        <td className="fw-semibold">{o.nome}</td>
                        <td className="small">{o.email || <span className="text-muted">—</span>}</td>
                        <td className="small">{o.whatsapp || <span className="text-muted">—</span>}</td>
                        <td className="small">{o.apelidos || <span className="text-muted">—</span>}</td>
                        <td className="small">
                          {o.login ? <span><i className="fas fa-user-check me-1 text-success"></i>{o.login}</span>
                            : <span className="text-warning" title="Nenhum usuário com este e-mail, nome ou apelido — o Painel do Operador não vai reconhecer esta pessoa ao logar"><i className="fas fa-triangle-exclamation me-1"></i>não reconhecido</span>}
                        </td>
                        <td className="small" title={(o.clientes || []).join(', ')}>
                          {(o.clientes || []).length ? `${o.clientes.length} empresa(s)` : <span className="text-muted">nenhuma</span>}
                        </td>
                        <td className="small">
                          {o.tem_senha
                            ? <span className="text-success"><i className="fas fa-key me-1"></i>cadastrada</span>
                            : <span className="text-danger"><i className="fas fa-key me-1"></i>falta — não envia e-mail</span>}
                        </td>
                        <td>{o.ativo ? <span className="badge bg-success">ativa</span> : <span className="badge bg-secondary">inativa</span>}</td>
                        <td className="text-end" style={{ whiteSpace: 'nowrap' }}>
                          <button className="btn btn-sm btn-outline-primary me-1" title="Editar" onClick={() => setForm({ id: o.id, nome: o.nome, email: o.email || '', whatsapp: o.whatsapp || '', apelidos: o.apelidos || '', senha_app: '' })}><i className="fas fa-pen"></i></button>
                          {o.tem_senha && <button className="btn btn-sm btn-outline-secondary me-1" title="Apagar a senha de app" onClick={() => limparSenha(o)}><i className="fas fa-key-skeleton fa-key"></i></button>}
                          <button className={`btn btn-sm ${o.ativo ? 'btn-outline-danger' : 'btn-outline-success'}`} title={o.ativo ? 'Inativar' : 'Reativar'} onClick={() => alternarAtivo(o)}>
                            <i className={`fas ${o.ativo ? 'fa-user-slash' : 'fa-user-check'}`}></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                    {lista.length === 0 && <tr><td colSpan={9} className="text-center text-muted py-4">Nenhuma operadora cadastrada.</td></tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )}

        {form && (
          <div className="modal show d-block" tabIndex="-1" style={{ background: 'rgba(0,0,0,.45)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content shadow-lg">
                <div className="modal-header" style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e9ecef' }}>
                  <div>
                    <h5 className="modal-title mb-0 fw-bold" style={{ color: '#212529' }}>
                      <i className={`fas ${form.id ? 'fa-pen' : 'fa-user-plus'} me-2`} style={{ color: '#00b5cc' }}></i>{form.id ? 'Editar operadora' : 'Nova operadora'}
                    </h5>
                    <small style={{ color: '#6c757d' }}>{form.id ? form.nome : 'quem atende clientes e envia e-mails pelo Saber'}</small>
                  </div>
                  <button type="button" className="btn-close" onClick={() => setForm(null)}></button>
                </div>
                <div className="modal-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label small fw-bold mb-1">Nome</label>
                      <input className="form-control" value={form.nome} onChange={(e) => setForm((f) => ({ ...f, nome: e.target.value }))} autoFocus />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-bold mb-1">Apelidos <span className="text-muted fw-normal">(separe por ;)</span></label>
                      <input className="form-control" placeholder="Fran; Francielle V." value={form.apelidos} onChange={(e) => setForm((f) => ({ ...f, apelidos: e.target.value }))} />
                      <div className="form-text">como o nome aparece no campo "operador" das empresas</div>
                    </div>
                    <div className="col-md-7">
                      <label className="form-label small fw-bold mb-1">E-mail (conta Gmail que envia)</label>
                      <input type="email" className="form-control" value={form.email} onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))} />
                    </div>
                    <div className="col-md-5">
                      <label className="form-label small fw-bold mb-1">WhatsApp</label>
                      <input className="form-control" placeholder="(51) 99999-9999" value={form.whatsapp} onChange={(e) => setForm((f) => ({ ...f, whatsapp: e.target.value }))} />
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-bold mb-1">Senha de app do Gmail <span className="text-muted fw-normal">(16 caracteres)</span></label>
                      <input type="password" className="form-control" autoComplete="new-password" placeholder={form.id ? 'deixe em branco para manter a atual' : 'xxxx xxxx xxxx xxxx'}
                        value={form.senha_app} onChange={(e) => setForm((f) => ({ ...f, senha_app: e.target.value }))} />
                      <div className="form-text">Gerada em Conta Google → Segurança → Senhas de app. É gravada e nunca mostrada de volta.</div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer bg-light">
                  <button className="btn btn-secondary me-auto" onClick={() => setForm(null)}><i className="fas fa-times me-2"></i>Cancelar</button>
                  <button className="btn btn-primary" onClick={salvar} disabled={salvando || !form.nome.trim()}>
                    <i className={`fas ${salvando ? 'fa-spinner fa-spin' : 'fa-floppy-disk'} me-2`}></i>{salvando ? 'Salvando...' : 'Salvar'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
